import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ICompanyListModel } from '@apps-common/types/management/company'

export const MANAGEMENT_QUERY_KEY_GET_COMPANIES = (name?: string, type?: string) => ['getCompanies', name, type].filter(Boolean)

export const getCompanies = async (name: string, type = ''): Promise<ICompanyListModel[]> =>
  axios.get(`/management/company/getcompanies?name=${name}&type=${type}`).then((res) => res.data?.data)

type QueryFnType = typeof getCompanies

type Props = {
  config?: QueryConfig<QueryFnType>
  name: string
  type?: string
}

export const useManagementGetCompanies = ({ config, name, type = '' }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: MANAGEMENT_QUERY_KEY_GET_COMPANIES(name, type),
    queryFn: () => getCompanies(name, type)
  })
